import { Component, OnInit, Output, EventEmitter, ElementRef } from "@angular/core";
import { CompanyService } from "../../../_services/company.service";
import { UserService } from "../../../_services/user.service";

declare var jQuery: any;

import "../../../../assets/semantic/semantic.min.js";
import { FormGroup, FormControl, Validators } from "@angular/forms";

@Component({
  selector: "app-new-user",
  templateUrl: "./new-user.component.html",
  styleUrls: ["./new-user.component.css"],
})

export class NewUserComponent implements OnInit {
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();
  private creating_user: boolean;
  private update_mode: boolean;
  private updating_user: boolean;
  private user_id: number;

  new_user: FormGroup;

  constructor(private elRef: ElementRef, private service: UserService, private company_service: CompanyService) { }
  
  ngOnInit() {
    
    this.new_user = new FormGroup({
      email: new FormControl('', [Validators.required]),
      encrypted_password: new FormControl('', [Validators.required]),
      company_id: new FormControl('', [Validators.required]),
      is_admin: new FormControl('')
    })
  }
  
  //oopen modal, si ID => update, sinon  c'est un create
  openModal(id = null) {
    if (id) {
      this.user_id = id;
      this.update_mode = true;
      this.service.getUser(id).subscribe(response => {
        
        //champ password n'est plus requis ds le cas d'un update
        this.new_user.get('encrypted_password').clearValidators();
        this.new_user.get('encrypted_password').updateValueAndValidity();
        //load les datas du user dans le form
        this.new_user.patchValue(response)
      })
    } else {
      //reset datas formulaire pour un ajout.
      this.new_user.reset();
    }

    jQuery("#addUser").modal({ inverted: true }).modal("show");
  }

  //sousmission du formulaire
  submitUserForm() {
    this.new_user.disable();
    jQuery("#addUser").modal({ closable: false });

    if (this.update_mode) {
      this.updating_user = true;
      this.updateUser();
    }
    else {
      this.creating_user = true;
      this.createUser();
    }
      
  }

  createUser() {
    this.service.addUser(this.new_user.value).subscribe((response) => {
      jQuery('#addUser').modal({ closable: true }).modal('hide');
      this.creating_user = false;
      this.new_user.enable();
      this.new_user.reset();

      this.refresh.emit(true);
      });
  }

  updateUser() {
    this.service.updateUser(this.user_id, this.new_user.value).subscribe((response) => {
      this.user_id = null;
      this.updating_user = false;
      this.new_user.enable();
      this.new_user.reset();

      jQuery('#addUser').modal({ closable: true }).modal('hide');

      this.refresh.emit(true);
      });
  }
}


// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/user/new-user/new-user.component.ts